import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
  SxProps,
  Theme,
} from "@mui/material";
import React from "react";

export interface WcRadioGroupInputData {
  value: string;
  label: string;
}
export type WcRadioProps = RadioProps;
export const WcRadio = (props: WcRadioProps) => <Radio {...props} />;

// ------------ main group export ------------
export type WcRadioGroupProps = RadioGroupProps & {
  title: string;
  inputData: WcRadioGroupInputData[];
  sx?: SxProps<Theme>;
  groupDisabled?: boolean;
  value?: string;
};

export const WcRadioGroup = ({
  title,
  inputData,
  sx,
  groupDisabled = false,
  value,
  ...props
}: WcRadioGroupProps) => (
  <FormControl sx={[...(Array.isArray(sx) ? sx : [sx])]}>
    <FormLabel id={`radio-group-${title}`}>{title}</FormLabel>
    <RadioGroup
      aria-labelledby={`radio-group-${title}`}
      name="radio-buttons-group"
      value={value || inputData[0].value}
      {...props}
    >
      {inputData.map((item, index) => (
        <FormControlLabel
          key={index}
          value={item.value}
          control={<WcRadio />}
          label={item.label}
          disabled={groupDisabled}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

export default WcRadioGroup;
